$(document).ready(function () {

    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    })

    $('#calculate-btn').on('click', (e) => {
        let pricePerItem = document.querySelector('.product-price').innerText
        let quantityInput = document.querySelector("#calc")

        let quantity = parseInt(quantityInput.value)

        let printingCost = parseInt((quantity -1) / 100 + 1 ) * 5

        if (quantity <= 100){
            printingCost = 5;
        }

        let result = pricePerItem * quantity + 15;

        let output = document.querySelector('#output-calc')

        output.innerHTML =
            `
                <ul style="font-family: 'Raleway', sans-serif; font-size: .9em;">
                    <li>
                        Pozivnice: ${parseFloat(quantity * pricePerItem).toFixed(2)} €
                    </li>
                    <li>
                        Priprema: 10 €
                    </li>
                    <li>
                        Štampa: 5 €
                    </li>
                    <hr>
                    <li style="font-size: 1em">
                        Ukupno: ${parseFloat(result).toFixed(2)} €
                    </li>
                </ul>
            `
    })

    $('.product-img--main')
        // tile mouse actions
        .on('mouseover', function () {
            if (window.matchMedia("only screen and (max-width: 1260px)").matches) {
                $(this).children('.product-img--main__image').css({'transform': 'scale(1)'});
            } else {
                $(this).children('.product-img--main__image').css({'transform': 'scale(' + $(this).attr('data-scale') + ')'});
            }
        })
        .on('mouseout', function () {
            $(this).children('.product-img--main__image').css({'transform': 'scale(1)'});
        })
        .on('mousemove', function (e) {
            $(this).children('.product-img--main__image').css({'transform-origin': ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '% ' + ((e.pageY - $(this).offset().top) / $(this).height()) * 100 + '%'});
        })
        // tiles set up
        .each(function () {
            $(this)
                // add a image container
                .append('<div class="product-img--main__image selected-img" id="mainImageSecond"></div>')
                // set up a background image for each tile based on data-image attribute
                .children('.product-img--main__image').css({'background-image': 'url(' + $(this).attr('data-image') + ')'});
        });
    (function () {
        const currentImage = document.querySelector('#currentImage');
        const images = document.querySelectorAll('.product-section-thumbnail');
        images.forEach((element) => element.addEventListener('click', thumbnailClick));

        function thumbnailClick(e) {

            document.getElementById('currentImage').setAttribute("data-image", this.querySelector('img').src);
            // document.querySelector('.lightbox-icon-1').setAttribute('href', this.querySelector('img').src)
            document.getElementById('mainImageSecond').setAttribute('style', "background-image: url('" + this.querySelector('img').src + "')");
            images.forEach((element) => element.classList.remove('selected'));
            this.classList.add('selected');
        }
    })();
});
